"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMOCODE_EXPIRATION_TYPE = void 0;
exports.PROMOCODE_EXPIRATION_TYPE = {
    NUMBER_OF_USES: 'NUMBER_OF_USES',
    ACTIVE_TILL: 'ACTIVE_TILL'
};
//# sourceMappingURL=promocodeExpirationType.js.map